<template>
<ContenedorCampos :titulo="titulo" :isObligatorio="Obligatorio" :error="error" class="under-sec">
  <div class="my-2">
    <v-row>
      <v-col cols="6" v-for="(foto, index) in aFotos" :key="index">
        <img :src="foto.Base64" width="100%" @click="ampliar(foto)">
        <v-btn small block color="red darken-2" class="mt-n2" @click="borrar(index)">
          <v-icon small dark color="white">mdi-delete</v-icon>
        </v-btn>
      </v-col>   
    </v-row>  
  </div>
  <div v-if="aFotos.length<nLimiteFotos">
    <Camera v-if="!getisAPP" @fotoCapture="verFoto"></Camera>
    <CameraAPP v-else @fotoCapture="verFoto"></CameraAPP>
  </div>
   <!-- MODAL PARA AMPLIAR FOTOS -->
  <AmpliarFoto 
    :fotoampliada="ftampliada" 
    :textoampliado="txtampliado" 
    v-model="showFoto"
  ></AmpliarFoto>

  <v-snackbar  v-model="isSnackBar" :timeout="3000" color="#0056d3">
    <v-icon left color="white">mdi-information-outline</v-icon>
    <span v-html="sMensaje" />
  </v-snackbar>
</ContenedorCampos>
</template>
<script>
import ContenedorCampos from '@/components/dinamicos/ContenedorCampos.vue'
import DinamicosMixin from '@/mixins/dinamicosMixin.js'
import Camera from '@/components/dinamicos/compAuxiliares/camera.vue'
import AmpliarFoto from '@/components/dinamicos/compAuxiliares/AmpliarFoto.vue'
import CameraAPP from '@/components/dinamicos/compAuxiliares/cameraAPP.vue'
import ValidarBD from "@/utils/ValidarBD.js"
import { mapGetters } from 'vuex'

export default {
  name: 'Foto',
  mixins: [ DinamicosMixin ], 
  components: {
    ContenedorCampos,
    Camera,
    AmpliarFoto,
    CameraAPP,
  },  
  data () {
    return {
      aFotos : [],
      ftampliada : null,
      txtampliado : null,
      showFoto : false,
      nLimiteFotos:5,
      sMensaje: '',
      isSnackBar: false
    }
  },
  mounted () {
    //Obtenemos el parametro general que obtiene la cantidad maxima de fotos
    const aParametros = ValidarBD.getInfoTabla('ParametrosGenerales')
    const oParametro = aParametros.find(item => item.Parametro == 'CantMaxFotoFD')
    if(oParametro?.Valor){
      this.nLimiteFotos = parseInt(oParametro?.Valor);
    }
    
  },
  methods: {
    verFoto(fotos){
      this.aFotos.push(fotos)
    },
    borrar(index) {
      this.aFotos.splice(index, 1)
    },
    ampliar(val){
      this.showFoto = true
      this.ftampliada = val.Base64
      //this.txtampliado = val.NombreFoto
    },
    getEquivalencia(sEquivalencia){
      if(sEquivalencia?.includes("??")){
        sEquivalencia = sEquivalencia.replaceAll("??", "");
        sEquivalencia = this.getoEquivalencia[sEquivalencia];
      }
      return sEquivalencia;
    }
  },
  computed: {
    ...mapGetters(['getisAPP','getoEquivalencia'])
  },
  watch: {
    aFotos(newFotos){
      this.selectValue = newFotos
      //Validamos que si llega al limite de fotos, se muestre el mensaje
      if(this.aFotos.length==this.nLimiteFotos){
        this.sMensaje = `El límite de fotos es de ${this.nLimiteFotos}`
        this.isSnackBar = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
